'use strict';

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('readable-stream'),
    Duplex = _require.Duplex;

var PullDuplexStream = /*#__PURE__*/function (_Duplex) {
  _inherits(PullDuplexStream, _Duplex);

  var _super = _createSuper(PullDuplexStream);

  function PullDuplexStream(source, sink, options) {
    var _this;

    _classCallCheck(this, PullDuplexStream);

    _this = _super.call(this, options);
    _this.source = source;
    _this.drainingSource = false;
    _this.sink = sink;
    _this.input = [];
    _this.writeCallbacks = [];
    _this.internalSourceCallbacks = [];

    if (_this.sink) {
      _this.sink(_this._internalSource.bind(_assertThisInitialized(_this)));
    }

    return _this;
  }

  _createClass(PullDuplexStream, [{
    key: "drainPull",
    value: function drainPull() {
      var self = this;
      this.drainingSource = true;
      this.source(null, function next(end, data) {
        if (end instanceof Error) {
          return self.emit('error', end);
        }

        if (end) {
          return self.push(null);
        }

        if (self.push(data)) {
          self.source(null, next);
        } else {
          self.drainingSource = false;
        }
      });
    }
  }, {
    key: "_read",
    value: function _read() {
      if (this.source && !this.drainingSource) {
        this.drainPull();
      }
    }
  }, {
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      if (this.internalSourceCallbacks.length > 0) {
        this.internalSourceCallbacks.shift()(null, chunk);
        callback();
      } else {
        this.input.push(chunk);
        this.writeCallbacks.push(callback);
      }
    }
  }, {
    key: "_internalSource",
    value: function _internalSource(end, cb) {
      if (end) {
        if (this.writeCallbacks.length > 0) {
          // call write callback with error
          this.writeCallbacks.shift()(end instanceof Error ? end : new Error('Aborted'));
        }

        return cb(end);
      }

      if (this.input.length > 0) {
        cb(null, this.input.shift());
        this.writeCallbacks.shift()();
      } else {
        this.internalSourceCallbacks.push(cb);
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      // end the internal source
      if (this.internalSourceCallbacks.length > 0) {
        this.internalSourceCallbacks.shift()(true);
      }

      callback();
    }
  }, {
    key: "_destroy",
    value: function _destroy(err, cb) {
      // abort the source
      if (!this._readableState.ended && this.source) {
        this.source(true, function () {// do nothing
        });
      } // propagate error to sink


      if (this.internalSourceCallbacks.length > 0) {
        this.internalSourceCallbacks.shift()(err);
      }

      cb(err);
    }
  }]);

  return PullDuplexStream;
}(Duplex);

function wrapper(source, sink, options) {
  if (source && typeof source === 'object') {
    source = source.source;
    sink = source.sink;
  }

  return new PullDuplexStream(source, sink, Object.assign({
    readableObjectMode: true,
    writableObjectMode: true
  }, options));
}

module.exports = {
  duplex: wrapper,
  readable: function readable(source, options) {
    return wrapper(source, null, options);
  },
  writeable: function writeable(sink, options) {
    return wrapper(null, sink, options);
  }
};